<script>
import {mapActions} from "pinia";
import {mainSearchStore} from "@/store/mainSearchStore";
import OpinionListItem from "@/components/MainSearch/SearchResult/Opinion/OpinionListItem.vue";
import BaseNoResultMessage from "@/components/BaseNoResultMessage.vue";
import InfiniteLoadingLoader from "@/components/InfiniteLoadingLoader.vue";

export default {
  name: "ProfileOpinionsList",
  components: {
    OpinionListItem,
    BaseNoResultMessage,
    InfiniteLoadingLoader
  },
  props: {
    isOwnProfile: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      searchParams: {
        creatorId: this.$route.params.id,
        creatorType: "USER",
        statuses: "CURRENT",
        page: 0,
        size: 10,
      },
      opinionsList: [],
      lastItems: false
    }
  },
  methods: {
    ...mapActions(mainSearchStore, [
        'getOpinionsAction'
    ]),
    infiniteHandler($state) {
      if ($state) {
        this.getOpinions($state);
      }
    },
    setStatus(status) {
      if (status !== this.searchParams.status) {
        this.searchParams.statuses = status;
        this.searchParams.page = 0;
        this.opinionsList = [];
        this.lastItems = false;
        this.getOpinionsAction(this.searchParams).then((resp)=> {
          this.opinionsList = this.opinionsList.concat(resp.data.content);
          this.searchParams.page += 1;
          this.lastItems = resp.data.numberOfElements < this.searchParams.size;
        })
      }
    },
    getOpinions($state) {
      if (!this.lastItems) {
        this.getOpinionsAction(this.searchParams).then((resp) => {
          this.opinionsList = this.opinionsList.concat(resp.data.content);
          this.searchParams.page += 1;
          this.lastItems = resp.data.numberOfElements < this.searchParams.size;

          if ($state) {
            if (this.opinionsList.length === 0) {
              $state.complete();
            } else {
              $state.loaded();
            }
          }
        });
      } else {
        $state.complete();
      }
    }
  }
}
</script>

<template>
<div class="profile-opinions-list">
  <div v-if="isOwnProfile" class="profile-content-sub-tabs">
    <div class="profile-content-sub-tab"
         :class="{'profile-content-sub-tab--active': searchParams.statuses === 'CURRENT'}"
         @click="setStatus('CURRENT')"
    >
      {{$t('profile.subTabs.current')}}
    </div>
    <div class="profile-content-sub-tab"
         :class="{'profile-content-sub-tab--active': searchParams.statuses === 'DRAFT'}"
         @click="setStatus('DRAFT')"
    >
      {{$t('profile.subTabs.drafts')}}
    </div>
  </div>
  <opinion-list-item v-for="item in opinionsList"
                     :key="item.id"
                     :item-data="item"
  />
  <infinite-loading @infinite="infiniteHandler">
    <template #spinner>
      <InfiniteLoadingLoader v-show="!lastItems"/>
    </template>
    <template #no-more>
      <div></div>
    </template>
    <template #no-results>
      <base-no-result-message :text="$t('profile.noOpinions')"/>
    </template>
  </infinite-loading>
</div>
</template>

<style lang="scss" scoped>
.profile-content-sub-tabs {
  display: flex;
  box-shadow: 0 2px 4px 0 rgba(79, 79, 79, 0.15);
  .profile-content-sub-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 27px;
    background: #f2f2f2;
    font-size: 12px;
    font-weight: 600;
    color: #bbb;
    cursor: pointer;

    &--active {
      color: #7130a0;
      background: #ffffff;
    }
  }
}

.profile-opinions-list {
  padding-top: 10px;
}
</style>